var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['list-loading',{'show':_vm.firstLoading}]},[_c('van-loading',{staticClass:"load-icon",attrs:{"size":"21","color":"#af2d2d"}},[_vm._v("加载中...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }